import { render, staticRenderFns } from "./liveshowGameTabs.vue?vue&type=template&id=49b997f2&"
import script from "./liveshowGameTabs.vue?vue&type=script&lang=js&"
export * from "./liveshowGameTabs.vue?vue&type=script&lang=js&"
import style0 from "./liveshowGameTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports